'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TravelIcon = require('./TravelIcon');

var _TravelIcon2 = _interopRequireDefault(_TravelIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TravelIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TravelIcon/index.js
// module id = 347
// module chunks = 0